import Config from '@config';
import { CACHE_EXPIRATION_TIME } from '@gasbi/shared/common/features/constants';

import { injectCrmSlice } from '@/app/crmApi';
import { UserPermissionType } from '@/features/permissions/types';

export const permissionsApi = injectCrmSlice({
  baseUrl: Config.VITE_API_URL + '/users',
  tagTypes: ['UserPermissions'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getUserPermissions: builder.query<UserPermissionType[], void>({
      query: () => ({
        url: `/permissions`,
      }),
      providesTags: ['UserPermissions'],
    }),
  }),
});

export const { useGetUserPermissionsQuery } = permissionsApi;
